import Metis from "./metis";
import Cart from "./module/shoppingCart";
import Storage from "./localStorage";

const metis = new Metis();
const storage = new Storage();
const cart = new Cart();

/**
 * Header cart
 */
document.addEventListener("DOMContentLoaded", async function () {
  const userIsLoggedIn = await metis.isLoggedIn();
  buildCartList(userIsLoggedIn, true);
  const cartDropdownButton = document.getElementById("cart_dropdown_button");
  if (cartDropdownButton) {
    cartDropdownButton.addEventListener("click", function () {buildCartList()});
  }
});

async function removeCourseFromCart(warenkorbKursKey) {
  const warenkorb = await cart.removeCourseFromCart(warenkorbKursKey);
  buildCartList();
}
async function removeBundleFromCart(warenkorbBundleKey) {
  const warenkorb = await cart.deleteBundleFromWarenkorb(warenkorbBundleKey);
  buildCartList();
}

async function buildCartList(userIsLoggedIn = null, firstLoad = false) {

  function formatPrice(price) {
    if (price != undefined || price != null) {
      return price.toLocaleString('de-DE', {maximumFractionDigits:2, minimumFractionDigits:2})
    }
    return ''
  }

  let cartContainer = document.getElementById("cartContainer");
  let course_in_cart = document.getElementById("course_in_cart");
  let tagTotalPrice = document.getElementById("shoppingCart_gesamtpreis");

  let cartLink = document.getElementById("cart-cart-nav-button");
  let checkoutLink = document.getElementById("cart-chekout-nav-button");

  let cartObj = storage.getWarenkorbObj();
  let localKeyExist = storage.getWarenkorbKey();
  let warenkorb = [];

  let loginStatusChanged = false;
  if (
    firstLoad &&
    userIsLoggedIn !== null &&
    cartObj &&
    cartObj.isLoggedIn !== undefined &&
    cartObj.isLoggedIn !== userIsLoggedIn
  ) {
    loginStatusChanged = true;
  }

  // has no guest cart when logging in
  if (loginStatusChanged && userIsLoggedIn) {
    // has no guest cart when logging in
    if (firstLoad && userIsLoggedIn && !localKeyExist) {
      localKeyExist = await cart.getUserCartFromMetis();
      if(localKeyExist) {
        warenkorb = await cart.getShoppingCart(localKeyExist);
        await cart.assignCartToUser(warenkorb);
      }

    // has guest cart when logging in
    } else if (firstLoad && userIsLoggedIn && localKeyExist) {
      if (localKeyExist) {
        warenkorb = await cart.getShoppingCart(localKeyExist);
        if (
          warenkorb &&
          (
            (warenkorb.warenkorbKurse && warenkorb.warenkorbKurse.length > 0) ||
            (warenkorb.bundles && warenkorb.bundles.length > 0)
          )
        ) {
          await cart.assignCartToUser(localKeyExist);
        } else {
          localKeyExist = await cart.getUserCartFromMetis();
          if (localKeyExist) {
            warenkorb = await cart.getShoppingCart(localKeyExist);
            await cart.assignCartToUser(localKeyExist);
          }
        }
      }
    }
  } else {
    if (localKeyExist) {
      if (loginStatusChanged) {
      }
      warenkorb = await cart.getShoppingCart(localKeyExist);
    }
  }

  if (firstLoad) {
    storage.storeWarenkorbKey(localKeyExist, userIsLoggedIn);
  }

  let total = 0;
  cartContainer.innerHTML = "";
  warenkorb?.warenkorbKurse?.forEach((item) => {
    total += item.anzahl;

    let cartItem = document.createElement("div");
    let itemDescription = document.createElement("p");
    let itemPriceContainer = document.createElement("p");
    let itemPriceTotal = document.createElement("span");
    let itemPrice = document.createElement("span");
    let deleteBtn = document.createElement("button");

    cartItem.className = "cart-dropdown__element";

    itemDescription.className = "cart-dropdown__element__title fw-bold text-primary body-sm";
    itemDescription.innerHTML = item.kurs.kursbez;

    itemPriceContainer.className = "mb-0 mb-1 cart-dropdown__element__price fw-bold body-sm";

    itemPriceTotal.className = "fw-normal";
    itemPriceTotal.innerHTML = item.anzahl + " x ";
    itemPrice.innerHTML = formatPrice(item.kurs.preis) + ' €';

    deleteBtn.className = "cart-dropdown__element__delete";
    deleteBtn.type = "button";
    deleteBtn.title = "Entfernen";
    deleteBtn.onclick = function () {
      removeCourseFromCart(item.warenkorbKursKey);
    };

    cartContainer.append(cartItem);
    cartItem.append(itemDescription);
    cartItem.append(itemPriceContainer);
    cartItem.append(deleteBtn);
    itemPriceContainer.append(itemPriceTotal);
    itemPriceContainer.append(itemPrice);
  });

  warenkorb?.bundles?.forEach((item) => {
    total += item.anzahl;

    let cartItem = document.createElement("div");
    let itemDescription = document.createElement("p");
    let itemPriceContainer = document.createElement("p");
    let itemPriceTotal = document.createElement("span");
    let itemPrice = document.createElement("span");
    let deleteBtn = document.createElement("button");

    cartItem.className = "cart-dropdown__element";

    itemDescription.className = "cart-dropdown__element__title fw-bold text-primary body-sm";
    itemDescription.innerHTML = '[Bundle] ' + item.bundleKonfiguration.bundleOberkategorie.bezeichnung;

    itemPriceContainer.className = "mb-0 mb-1 cart-dropdown__element__price fw-bold body-sm";

    itemPriceTotal.className = "fw-normal";
    itemPriceTotal.innerHTML = item.anzahl + " x ";
    itemPrice.innerHTML = formatPrice(item.einzelpreis) + ' €';

    deleteBtn.className = "cart-dropdown__element__delete";
    deleteBtn.type = "button";
    deleteBtn.onclick = function () {
      removeBundleFromCart(item.warenkorbBundleKey);
    };

    cartContainer.append(cartItem);
    cartItem.append(itemDescription);
    cartItem.append(itemPriceContainer);
    cartItem.append(deleteBtn);
    itemPriceContainer.append(itemPriceTotal);
    itemPriceContainer.append(itemPrice);
  });

  // Assign values to the html element
  course_in_cart.innerHTML = total;
  tagTotalPrice.innerHTML = formatPrice(warenkorb?.gesamtpreis ? warenkorb.gesamtpreis : 0);

  cartLink.dataset.price = warenkorb?.gesamtpreis ? warenkorb.gesamtpreis : 0;
  checkoutLink.dataset.price = warenkorb?.gesamtpreis ? warenkorb.gesamtpreis : 0;

  // update header course number
  const tagTotalCoursesContainer = document.getElementById("cart-dropdown__count");
  const tagTotalCourses = document.getElementById("cart-dropdown__count__span");
  if (tagTotalCoursesContainer && tagTotalCourses) {
    total > 0 ? tagTotalCoursesContainer.style.display = 'block' : tagTotalCoursesContainer.style.display = 'none';
    tagTotalCourses.innerHTML = total;
  }

  if(total > 0) {
    document.querySelector('#cart-chekout-nav-button')?.classList?.remove('disabled');
  } else {
    document.querySelector('#cart-chekout-nav-button')?.classList?.add('disabled');
  }
}

const alpineData = () => {
  return {
    shoppingCart: [],
    coursesInWarenkorb: 0,
    bundlesInWarenkorb: 0,
    totalElementsInWarenkorb: 0,

    init: async function() {
      document.addEventListener("add-bundle-config-to-cart", async (event) => {
        const configuration = event.detail.bundleConfiguration;
        this.addBundleToCart(configuration);
      });
    },

    addCourseToCart: async function (courseID, price) {
      this.addElementToCart('course', {courseID: courseID}, price);
    },

    removeCourseFromCart: async function (warenkorbKursKey) {
      this.removeElementFromCart('course', {warenkorbKursKey: warenkorbKursKey});
    },

    addBundleToCart: async function (bundleConfiguration) {
      this.addElementToCart('bundle', bundleConfiguration);
    },

    removeBundleFromCart: async function (warenkorbBundleKey) {
      this.removeElementFromCart('bundle', {warenkorbBundleKey: warenkorbBundleKey});
    },

    addElementToCart: async function (type, data, price = 0) {
      const localWarenkorbKey = storage.getWarenkorbKey();
      const isLoggedIn = await metis.isLoggedIn();

      if (localWarenkorbKey) {
        if(type === 'course') {
          const res = await cart.addCourseToCart(localWarenkorbKey, data.courseID);
        } else if(type == "bundle") {
          const res = await cart.addBundleToWarenkorb(localWarenkorbKey, data.bundleKonfigurationKey);
        }

        if (isLoggedIn) {
          const result = await this.assignCarttoUser(localWarenkorbKey);
        }
      } else {

        let newWarenkorbKey = null;
        if(type === 'course') {
          const requestCreateCart = cart.createCart(data.courseID);
          newWarenkorbKey = await requestCreateCart;
        } else if(type == "bundle") {
          const requestCreateCart = cart.addBundleAndCreateWarenkorb(data.bundleKonfigurationKey);
          newWarenkorbKey = await requestCreateCart;
        }

        const res = storage.storeWarenkorbKey(newWarenkorbKey.warenkorbKey, isLoggedIn);

        if (isLoggedIn) {
          const result = await this.assignCarttoUser(newWarenkorbKey.warenkorbKey);
        }
      }

      // Google-Analytics
      if(type === 'course') {
        window.gtag_custom_func('AddToCart', {course: data.courseID, price: price});
      } else if(type == "bundle") {
        window.gtag_custom_func('AddToCart', {bundleKonfigurationKey: data.bundleKonfigurationKey});
      }

      const result = await this.getDropdownList();
    },

    removeElementFromCart: async function (type, data) {
      let warenkorb = null;
      if(type === 'course') {
        warenkorb = await cart.removeCourseFromCart(data.warenkorbKursKey);
      } else if(type == "bundle") {
        warenkorb = await cart.deleteBundleFromWarenkorb(data.warenkorbBundleKey);
      }
      this.shoppingCart = warenkorb;
      document.dispatchEvent(new CustomEvent('updated-shoppingCart', {detail: {cart: warenkorb}}));
      this.coursesInWarenkorb = warenkorb.warenkorbKurse.length;
      this.bundlesInWarenkorb = warenkorb.bundles.length;
      let total = 0;
      warenkorb.warenkorbKurse.forEach((item) => (total += item.anzahl));
      warenkorb.bundles.forEach((item) => (total += item.anzahl));
      this.totalElementsInWarenkorb = total;

      // update header course number
      const tagTotalCoursesContainer = document.getElementById("cart-dropdown__count");
      const tagTotalCourses = document.getElementById("cart-dropdown__count__span");
      if (tagTotalCoursesContainer && tagTotalCourses) {
        total > 0 ? tagTotalCoursesContainer.style.display = 'block' : tagTotalCoursesContainer.display = 'none';
        tagTotalCourses.innerHTML = total;
      }
    },

    assignCarttoUser: async function (warenkorb) {
      const userWarenkorb = await cart.getCurrentUserCart();
      if (userWarenkorb != warenkorb) {
        cart.assignCartToUser(warenkorb);
      }
    },

    getDropdownList: async function () {
      const localKeyExist = storage.getWarenkorbKey();
      if (localKeyExist) {
        // console.log(localKeyExist);
        const warenkorb = await cart.getShoppingCart(localKeyExist);
        this.shoppingCart = warenkorb;
        document.dispatchEvent(new CustomEvent('updated-shoppingCart', {detail: {cart: warenkorb}}));
        this.coursesInWarenkorb = Object.values(warenkorb.warenkorbKurse).length;
        this.bundlesInWarenkorb = Object.values(warenkorb.bundles).length;
        let total = 0;
        warenkorb.warenkorbKurse.forEach((item) => (total += item.anzahl));
        warenkorb.bundles.forEach((item) => (total += item.anzahl));
        this.totalElementsInWarenkorb = total;

        // update header course number
        const tagTotalCoursesContainer = document.getElementById("cart-dropdown__count");
        const tagTotalCourses = document.getElementById("cart-dropdown__count__span");
        if (tagTotalCoursesContainer && tagTotalCourses) {
          total > 0 ? tagTotalCoursesContainer.style.display = 'block' : tagTotalCoursesContainer.style.display = 'none';
          tagTotalCourses.innerHTML = total;
        }
      }
    },

    hoveredOverCartButton: function(courseID, price) {
      window.gtag_custom_func('AddToCartHover', {course: courseID, price: price});
    }
  };
};

if(!window.alpineData) {
  window.alpineData = {};
}
window.alpineData.appCart = alpineData;
